module.exports = __webpack_public_path__ + "media/svg-new/acessar-conteudo-338d1073.svg";